<template>
   <div id="controles-mapa" class="controles-mapa">
      <h3 class="titulo">Controles</h3>
      <div class="radio-mapa">
         <input type="radio" id="personas" value="personas" v-model="opcionElegida" @click="$emit('pintarDeptos','personas')">
         <label for="prop-mujeres">Población</label>
      </div>
      <br>
      <div class="radio-mapa">
         <input type="radio" id="viviendas_" value="viviendas_" v-model="opcionElegida" @click="$emit('pintarDeptos','viviendas_')">
         <label for="prop-mujeres">Viviendas</label>
      </div>
      <br>
      <div class="radio-mapa">
         <input type="radio" id="prop-hombres" value="prop-hombres" v-model="opcionElegida" @click="$emit('pintarProp','prop_hombres')">
         <label for="prop-mujeres">Proporción de hombres</label>
      </div>
      <br>
      <div class="radio-mapa">
         <input type="radio" id="prop-mujeres" value="prop-mujeres" v-model="opcionElegida" @click="$emit('pintarProp','prop_mujeres')">
         <label for="prop-mujeres">Proporción de mujeres</label>
      </div>
      <br>
      <div class="radio-mapa">
         <input type="radio" id="semaforo" value="semaforo" v-model="opcionElegida" @click="$emit('pintarProp','semaforo')">
         <label for="pintarProp">Semáforo</label>
      </div>
   </div>
</template>
<script>
   export default {
        name: "ControlesMapa",
       data: function() {
        return {
                   opcionElegida: null
           }
       }
    }
</script>
<style scoped>
   .titulo{
    margin-top: 0!important;
   }
   .controles-mapa{
   text-align: left;
   margin-left: 2em;
   }
   .radio-mapa{
   padding-bottom: 0.5rem;
   margin-right: 0.5rem;
   }
   input{
    margin-right: 0.5rem;
   }
   .controles-mapa:hover{

   }
</style>